import produce from "immer";
import treeData from "../../data/tree.json";
import { generateFromAbridgedBits } from "../bitFactory";
import { generateEntity } from "../entityFactory";
import { IBoardTile, IState } from "../types";
import { IReducerAction } from "./types";

const tileInfo = treeData.tiles as Record<string, IBoardTile>;

function pickNextWaveActor(draft: IState) {
  const { wave } = draft.pick;
  // attempt to go to next actor in wave, otherwise go to next wave
  if (draft.waves[wave.index].actors[wave.actorIndex + 1]) wave.actorIndex += 1;
  else {
    wave.index = (wave.index + 1) % draft.waves.length;
    wave.actorIndex = 0;
  }
}

function addBits(draft: IState, id: string) {
  if (tileInfo[id]) {
    if (tileInfo[id].cost > draft.board.points) return;

    const newBits = generateFromAbridgedBits(tileInfo[id].unlock);
    draft.bits.targets = draft.bits.targets.concat(newBits.targets);
    draft.bits.conditions = draft.bits.conditions.concat(newBits.conditions);
    draft.bits.actions = draft.bits.actions.concat(newBits.actions);

    draft.board.activeTiles[id] = true;
    draft.board.points -= tileInfo[id].cost;
  }
}

export default function spendReducer(
  state: IState,
  action: IReducerAction
): IState {
  const newState = produce(state, draft => {
    draft.turn.battle = 0;
    draft.actors = draft.actors.map(actor => {
      const isDead = actor.stats.hp.value <= 0;
      if (isDead) {
        pickNextWaveActor(draft);
        const { actorIndex, index } = draft.pick.wave;
        const waveActor = state.waves[index].actors[actorIndex];
        // fixme: this assumes only two actors ever present in a battlefield
        draft.turn.battleDuration = waveActor.battleDuration;
        return generateEntity(waveActor);
      }
      return actor;
    });
    draft.screen.previous = draft.screen.current;
    draft.screen.current = "#battle";
  });
  const { payload } = action;
  if (payload === undefined) return newState;
  if (!("id" in payload)) return newState;
  return produce(state, draft => {
    addBits(draft, payload.id);
  });
}
